import api from "aio-api";

function sortBudgets (budgetA, budgetB) {
  if (!budgetA.parentId) return -1
  else if (!budgetB.parentId) return 1
  else if (budgetA.name.toLowerCase() < budgetB.name.toLowerCase()) return -1
  else if (budgetA.name.toLowerCase() > budgetB.name.toLowerCase()) return 1
  else return 0
}

export default {
  namespaced: true,
  state: {
    budgets: {},
  },
  mutations: {
    set: (state, budgets) => state.budgets = budgets,
  },
  getters: {
    budgets: state => Object.values(state.budgets).sort(sortBudgets),

    active: (state, getters) => getters.budgets.filter(b => b.status !== 'inactive'),
    inactive: (state, getters) => getters.budgets.filter(b => b.status === 'inactive'),
    activeManaged: (state, getters, rootState, rootGetters) => {
      if (rootGetters.isAdmin) {
        return getters.active
      } else {
        return getters.active.filter(b => b.managerIds?.includes(rootGetters.currentUserId))
      }
    },
    masterBudget: (state, getters) => getters.budgets.find(b => !b.parentId),
  },
  actions: {
    fetch: async (context) => {
      const apiResponse = await api.getBudgets()
      const budgets = Object.fromEntries(apiResponse.map(b => [b.potId, b]))
      context.commit('set', budgets)
    },
  },
}
